export function transformJSONStringToArrayObjects(
  input: string | null | undefined,
): ValueField[] | null {
  if (typeof input !== "string") {
    return null;
  }
  try {
    const parsedInput: unknown = JSON.parse(input);
    if (!Array.isArray(parsedInput) || parsedInput.length === 0) {
      return null;
    }
    return parsedInput.map((item: string) => ({ value: item }));
  } catch {
    return null;
  }
}
